import React from 'react';
import ProductLink from '~/components/Product/Link';
import { Flex } from 'theme-ui';
import useCTAStyle from '~/hooks/components/use-cta-style';
import CardContent from './CardContent';
import { BundleSpotlight, KitSpotlight } from '../utils';
import QuickshopCardWrapper from './CardWrapper';

type Props = {
  spotlight: BundleSpotlight | KitSpotlight;
  layout: 'horizontal' | 'vertical';
};

const QuickshopBundleCard = ({ spotlight, layout }: Props) => {
  const CTAStyles = useCTAStyle({ baseColor: 'Black', variant: 'Filled', size: 'Medium', disableDisabledStyle: false });
  const { badge } = spotlight;
  return (
    <QuickshopCardWrapper spotlight={spotlight} layout={layout} badge={badge}>
      <CardContent
        spotlight={spotlight}
        regularPrice={spotlight?.content.regularPrice}
        price={spotlight?.content?.price}
      />
      <Flex sx={{ justifyContent: 'flex-end', gridArea: 'cta' }}>
        <ProductLink
          productName={spotlight?.content?.name}
          productSlug={spotlight?.content?.slug}
          collectionSlug={spotlight?.content?.collection?.[0]?.slug}
          locationDetail={'Quickshop'}
          sx={{ ...CTAStyles }}
        >
          shop now
        </ProductLink>
      </Flex>
    </QuickshopCardWrapper>
  );
};

export default QuickshopBundleCard;
